<div class="zk-w-full zk-flex zk-flex-wrap subscription-data">
	<div class="xl:zk-w-5/12 lg:zk-w-5/12 md:zk-w-full">
		<section class="content">
			<h1 class="title">
				{{ 'SIGN_UP.SUBSCRIPTION_DATA.TITLE' | translate }}
			</h1>
			<h2 class="subtitle">
				{{ 'SIGN_UP.SUBSCRIPTION_DATA.SUBTITLE' | translate }}
			</h2>
			<h5 class="description">
				{{ 'SIGN_UP.SUBSCRIPTION_DATA.DESCRIPTION' | translate }}
			</h5>
		</section>
	</div>
	<form
		class="xl:zk-w-7/12 lg:zk-w-7/12 md:zk-w-full sm:zk-w-full"
		[formGroup]="form"
	>
		<div class="zk-w-full zk-flex zk-flex-wrap">
			<div
				class="form-item xl:zk-w-6/12 lg:zk-w-6/12 md:zk-w-6/12 sm:zk-w-full"
			>
				<label class="zk-w-full" for="name">{{
					'SIGN_UP.SUBSCRIPTION_DATA.NAME' | translate
				}}</label>
				<input
					(keyup)="canSubmit('name', $event)"
					formControlName="name"
					class="zk-w-full"
					id="name"
					[placeholder]="
						'SIGN_UP.SUBSCRIPTION_DATA.NAME_DESCRIPTION' | translate
					"
				/>
				<span class="zk--mb-2">
					{{ getErrorMessage('name') }}
				</span>
			</div>
			<div
				class="form-item xl:zk-w-6/12 lg:zk-w-6/12 md:zk-w-6/12 sm:zk-w-full"
			>
				<label class="zk-w-full" for="email">{{
					'SIGN_UP.SUBSCRIPTION_DATA.EMAIL' | translate
				}}</label>
				<input
					(keyup)="canSubmit('email', $event)"
					formControlName="email"
					class="zk-w-full"
					id="email"
					type="email"
					[placeholder]="
						'SIGN_UP.SUBSCRIPTION_DATA.EMAIL_DESCRIPTION' | translate
					"
				/>
				<span class="zk--mb-2">
					{{ getErrorMessage('email') }}
				</span>
			</div>
		</div>
		<div class="zk-w-full zk-flex zk-flex-wrap">
			<div
				class="form-item xl:zk-w-6/12 lg:zk-w-6/12 md:zk-w-6/12 sm:zk-w-full"
			>
				<app-password-validation
					(keyup)="canSubmit('password', $event)"
					(passwordItem)="setCurrentPassword($event)"
					[fieldLabel]="'Senha'"
				></app-password-validation>
			</div>
			<div
				class="form-item xl:zk-w-6/12 lg:zk-w-6/12 md:zk-w-6/12 sm:zk-w-full"
			>
				<app-password-validation
					[currentPasswordValue]="this.currentPassword"
					[fieldLabel]="'Confirmação de senha'"
					(validPassword)="canSubmit('password', $event)"
				></app-password-validation>
			</div>
		</div>
	</form>
</div>
